import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { GlobalService } from 'src/app/services/global.service';
import { LocalStorageService } from 'src/app/services/local-storage.service';

@Injectable({
  providedIn: 'root'
})
export class SideBarService {

  constructor(
    private http: HttpClient,
    private globalService:GlobalService,
    private localStorageS:LocalStorageService
  ) { }

  getAllModules(id: number) : Observable<any> {
    return this.http.get(`${environment.apiUrl}/modules/getall/${id}`);
  }


  getModulesRoute(id: number) : Observable<string[]> {
    return this.http.get<string[]>(`${environment.apiUrl}/roles/getmodules/${id}`);
  }

  setImage(): string{

    switch (this.localStorageS.getAppTheme()) {
      case 'dark': {
        return environment.logoDark;
      };
      case 'light': {
        return environment.logo;
      
      };
      case 'system': {
        if (this.globalService.isDark()) {
          return environment.logoDark;
        } else {
          return environment.logo;
        }
        break;
      };
      default: {
        return environment.logo;
      }
    }
  }

}


